/**
 * Exchanges a Cognito ID token for a Firebase custom token via the backend.
 *
 * This is used after Cognito authentication (password or magic link) so that
 * users get a Firebase session for backward compatibility with the legacy app.
 */
export async function exchangeCognitoTokenForFirebase(cognitoIdToken: string): Promise<string> {
  const response = await fetch(
    `${(globalThis as unknown as Record<string, string>).api}/auth/exchange-cognito-token`,
    {
      method: "GET",
      headers: {
        Authorization: `Bearer ${cognitoIdToken}`,
      },
    }
  );

  if (!response.ok) {
    throw new Error(`Token exchange failed: ${response.status}`);
  }

  const data = (await response.json()) as { firebaseCustomToken?: string };
  if (!data.firebaseCustomToken) {
    throw new Error("Token exchange missing firebase custom token");
  }
  return data.firebaseCustomToken;
}
